export default __webpack_public_path__ + "src/docs/packages/oceana-beach-wildlife-reserve.pdf";